import React from 'react';
import { Grid, Box } from '../../../';
var COLORS = [{
  color: '#C95E8F'
}, {
  color: '#EF727B'
}, {
  color: '#F08850'
}, {
  color: '#F99A5B'
}, {
  color: '#FFAA63'
}, {
  color: '#FFB762'
}, {
  color: '#F9C661'
}, {
  color: '#F4DE69'
}, {
  color: '#BAD5A4'
}, {
  color: '#6DCCC7'
}, {
  color: '#1F98B6'
}, {
  color: '#137099'
}, {
  color: '#0E6188'
}, {
  color: '#074773'
}, {
  color: '#04386C'
}, {
  color: '#012354'
}];

var Rainbow = function Rainbow(_ref) {
  var _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation;

  if (orientation == 'vertical') {
    return React.createElement(Grid, {
      item: true,
      sx: {
        height: '60px',
        width: '3px',
        display: 'flex',
        flexDirection: 'column-reverse',
        alignItems: 'center',
        mb: {
          xs: '32px',
          md: '60px'
        }
      }
    }, COLORS.map(function (color, index) {
      return React.createElement(Box, {
        key: index,
        sx: {
          width: '100%',
          height: '8.33%',
          backgroundColor: "".concat(color.color)
        }
      });
    }));
  }

  return React.createElement(Grid, {
    container: true,
    sx: {
      height: {
        xs: '5px',
        md: '15px'
      },
      width: '100%'
    }
  }, COLORS.map(function (color, index) {
    return React.createElement(Box, {
      key: index,
      sx: {
        width: '6.25%',
        height: '100%',
        backgroundColor: "".concat(color.color)
      }
    });
  }));
};

export default Rainbow;